import React from "react";
import logo from "../images/logo.png";

const Layout = ({ children, goToStep, onBack, isFirstStep, hideBack }) => {
  return (
    <section className="bg-[#F5F7FB] min-h-screen flex items-center justify-center font-poppins ">
      <div className="bg-white border border-[#E5E7EB] rounded-2xl shadow-sm w-full max-w-xl px-6 sm:px-8 py-8 sm:py-10 relative my-10">

        {/* Back Button */}
        {!hideBack && (
          <button
            type="button"
            className="absolute left-[1.75rem] top-[3rem] text-black text-2xl leading-none"
           
            onClick={() => {
              if (isFirstStep) {
                window.history.back();
              } else if (onBack) {
                onBack();
              }
            }}
          >
            ←
          </button>
        )}

        {/* Logo (clickable home) */}
        <div
          className="flex justify-center mb-6 cursor-pointer"
          onClick={() => goToStep && goToStep(1)}
        >
          <img
            src={logo}
            alt="Slimming Doctor"
            className="h-12 sm:h-14 object-contain"
          />
        </div>

        {/* Page Content */}
        {children}
      </div>
    </section>
  );
};

export default Layout;
